import React, { useState, useEffect } from "react";
import {
  Box,
  Tabs,
  Tab,
  Typography,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Button,
} from "@mui/material";
import Layout from "../common/Layout";
// Use the shared BookingSystem component for bookings UI
import BookingSystem from "../admin/BookingSystem";
import UserManagement from "./UserManagement";
import { tokenAPI } from "../../utils/api";

// Component to handle student registration tokens
const TokenGenerator = () => {
  const [tokens, setTokens] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const fetchTokens = async () => {
    setLoading(true);
    try {
      const res = await tokenAPI.getAll();
      setTokens(res.data || []);
    } catch (err) {
      console.error("Error fetching tokens:", err);
      setError("Failed to load tokens.");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchTokens();
  }, []);

  const handleGenerate = async () => {
    setLoading(true);
    try {
      await tokenAPI.create();
      await fetchTokens();
    } catch (err) {
      console.error("Error generating token:", err);
      setError("Failed to generate token.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Paper sx={{ p: 2 }}>
      <Typography variant="h6">Student Registration Tokens</Typography>
      {error && <Typography color="error">{error}</Typography>}
      <Box sx={{ my: 2 }}>
        <Button variant="contained" onClick={handleGenerate} disabled={loading}>
          {loading ? "Generating..." : "Generate New Token"}
        </Button>
      </Box>
      <TableContainer component={Paper}>
        <Table size="small">
          <TableHead>
            <TableRow>
              <TableCell>Token</TableCell>
              <TableCell>Created At</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {tokens.map((t) => (
              <TableRow key={t.id}>
                <TableCell>{t.token}</TableCell>
                <TableCell>{new Date(t.createdAt).toLocaleString()}</TableCell>
              </TableRow>
            ))}
            {tokens.length === 0 && !loading && (
              <TableRow>
                <TableCell colSpan={2} align="center">
                  No tokens found.
                </TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>
      </TableContainer>
    </Paper>
  );
};

const InventoryManager = () => (
  <Paper sx={{ p: 2 }}>
    <Typography variant="h6">Department Inventory</Typography>
    <Typography variant="body2" sx={{ mt: 1 }}>
      View and update inventory items for your department.
    </Typography>
  </Paper>
);

const Reports = () => (
  <Paper sx={{ p: 2 }}>
    <Typography variant="h6">Reports & Analytics</Typography>
    <Typography variant="body2" sx={{ mt: 1 }}>
      Access departmental reports and analytics dashboards.
    </Typography>
  </Paper>
);

const NotificationsPanel = () => (
  <Paper sx={{ p: 2 }}>
    <Typography variant="h6">Notifications</Typography>
    <Typography variant="body2" sx={{ mt: 1 }}>
      Receive and review real-time departmental notifications.
    </Typography>
  </Paper>
);

const FacultyDashboard = () => {
  const [activeTab, setActiveTab] = useState(0);

  const handleTabChange = (event, newValue) => {
    setActiveTab(newValue);
  };

  return (
    <Layout>
      <Box sx={{ py: 2, px: { xs: 2, md: 3 } }}>
        <Tabs
          value={activeTab}
          onChange={handleTabChange}
          indicatorColor="primary"
          textColor="primary"
          variant="scrollable"
          scrollButtons="auto"
        >
          <Tab label="Bookings" />
          <Tab label="User Management" />
          <Tab label="Tokens" />
          <Tab label="Inventory" />
          <Tab label="Reports" />
          <Tab label="Notifications" />
        </Tabs>

        <Box sx={{ mt: 2 }}>
          {activeTab === 0 && <BookingSystem />}
          {activeTab === 1 && <UserManagement />}
          {activeTab === 2 && <TokenGenerator />}
          {activeTab === 3 && <InventoryManager />}
          {activeTab === 4 && <Reports />}
          {activeTab === 5 && <NotificationsPanel />}
        </Box>
      </Box>
    </Layout>
  );
};

export default FacultyDashboard;
